const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsProdutos = { name: 'Produtos', pathName: null, action: 'produtos' }

export default [
  {
    path: 'ranking-produtos',
    name: 'ranking-produtos',
    component: () => import('@/modules/produtos/ranking-produtos/views/pages/RankingProdutos.vue'),
    meta: {
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsProdutos,
        {
          name: 'Ranking de produtos',
          pathName: null,
        },
      ],
      title: 'Ranking de produtos',
      allowOnlyMercapromo: true,
      requiredUserPermissions: ['produtos/ranking_produtos'],
    },
  },
]
